<script setup>

import {ref} from "vue";

const props = defineProps({
  isOpen: {type: Boolean, default: false},
})

const emit = defineEmits(['close', 'save'])

const name = ref('')
</script>
<template>
  <transition name="fade">
    <div v-if="props.isOpen"
         class="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-50 p-4"
         @click.self="emit('close')"
    >
      <div
        class="bg-white p-8 rounded-[4px] shadow-2xl max-w-[480px] w-full relative overflow-hidden">
        <!-- Header -->
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-xl font-bold text-dark_blue">Create Template</h3>
          <button @click="emit('close')" class="text-slate-500 hover:text-red-400 transition-colors">
            <i class="fas fa-times text-xl"></i>
          </button>
        </div>

        <div>

          <div class="space-y-2">
            <span class="font-bold text-dark_blue text-[12px]">Template name</span>
            <el-input v-model="name" size="large"/>
          </div>
        </div>

        <div class="flex gap-2 justify-end mt-4">
          <button @click="emit('close')" class="py-3 px-5 rounded-[4px] bg-orange-450 text-white font-bold text-sm">
            Cancel
          </button>
          <button @click="emit('save', name)"
                  class="py-3 px-5 rounded-[4px] bg-blue-450 text-white font-bold text-sm"
                  :class="{'bg-gray-400': !name}"
                  :disabled="!name">
            Save
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>
